/**
 * Typed re-export wrapper for shadcn's alert-dialog (.jsx file).
 * Provides proper React component typings to .tsx callers.
 */
import * as React from 'react';
import * as Raw from './alert-dialog.jsx';

type DivProps = React.HTMLAttributes<HTMLDivElement>;
type BtnProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

export const AlertDialog = Raw.AlertDialog as React.FC<{
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  children?: React.ReactNode;
}>;
export const AlertDialogTrigger = Raw.AlertDialogTrigger as React.FC<{ children?: React.ReactNode; asChild?: boolean }>;
export const AlertDialogPortal = Raw.AlertDialogPortal as React.FC<{ children?: React.ReactNode }>;
export const AlertDialogOverlay = Raw.AlertDialogOverlay as React.FC<DivProps>;
export const AlertDialogContent = Raw.AlertDialogContent as React.FC<DivProps>;
export const AlertDialogHeader = Raw.AlertDialogHeader as React.FC<DivProps>;
export const AlertDialogFooter = Raw.AlertDialogFooter as React.FC<DivProps>;
export const AlertDialogTitle = Raw.AlertDialogTitle as React.FC<DivProps>;
export const AlertDialogDescription = Raw.AlertDialogDescription as React.FC<DivProps>;
export const AlertDialogAction = Raw.AlertDialogAction as React.FC<BtnProps>;
export const AlertDialogCancel = Raw.AlertDialogCancel as React.FC<BtnProps>;
